var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-responsive text-center" },
        [
          _c(
            "l-table",
            {
              staticClass:
                "table table-light table-light table-bordered table-hover",
              attrs: { columns: _vm.contents.columns, data: _vm.contents.data }
            },
            [
              _vm.contents.data.length
                ? _c(
                    "template",
                    { slot: "table-row" },
                    _vm._l(_vm.contents.data, function(item, index) {
                      return _c(
                        "tr",
                        {
                          key: index,
                          class: { inactive: item.status === "0" }
                        },
                        [
                          _c("td", [_vm._v(_vm._s(item.page_name || "-"))]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              {
                                staticClass: "btn-group",
                                attrs: { role: "group" }
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.top-center",
                                        value: _vm.contents.tooltips.view,
                                        expression: "contents.tooltips.view",
                                        modifiers: { "top-center": true }
                                      }
                                    ],
                                    staticClass: "btn btn-secondary btn-sm",
                                    on: {
                                      click: function($event) {
                                        return _vm.viewContent(item)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fa fa-eye" })]
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row align-items-center mb-1" }, [
      _c("div", { staticClass: "col-md-6" }, [
        _c("div", { staticClass: "h2" }, [_vm._v("Contents")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c2d3925a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2d3925a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Tags/Tags.vue
// module id = URG6
// module chunks = 0